export default __webpack_public_path__ + "static/media/help.e88954a1.png";